<template>
  <div class="BurgerMenu">
    <div class="BurgerMenuHeader">
      <nuxt-link
        :event="useAuthStore().user && useAuthStore().user?.is_temp ? '' : 'click'"
        :to="localePath('/')"
      >
        <logo-svg />
      </nuxt-link>
      <el-button
        circle
        @click="useUIStore().burgerMenu = false"
      >
        <icon-close />
      </el-button>
    </div>
    <div class="BurgerMenuUser">
      <UserAvatar
        :user="useAuthStore().user"
        class="mb-2"
      />
      <span class="text-text-light-pink font-semibold">
        {{ useAuthStore().user?.last_name ? `${useAuthStore().user?.first_name} ${useAuthStore().user?.last_name}` : (useAuthStore().user?.name ? useAuthStore().user?.name : useAuthStore().user?.email) }}
      </span>
    </div>
    <div class="BurgerMenuNavigation">
      <slot />

      <nuxt-link
        :to="localePath(`${useAuthStore().user?.is_operator ? '/operator' : ''}/settings/${useAuthStore().user?.type === 2 ? 'organization' : 'personal-data'}`)"
      >
        {{ $t('AppHeader.settings') }}
      </nuxt-link>
      <nuxt-link
        :to="localePath('/login')"
        @click="useLogout()"
      >
        {{ $t('AppHeader.logout') }}
      </nuxt-link>
    </div>
  </div>
</template>

<script setup>
import LogoSvg from '~/assets/img/logo.svg';

const localePath = useLocalePath();
</script>

<style scoped>
@reference "assets/css/tailwind.css";

.BurgerMenu {
  position: fixed;
  inset: 0;
  width: 100%;
  height: 100%;
  z-index: 1234;

  @apply bg-primary-500;
  @apply text-white;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding-top: env(safe-area-inset-top);

  .BurgerMenuHeader {
    height: var(--header-height-small);
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding-left: 24px;
    padding-right: 20px;

    a {
      @apply text-white;
    }

    @media (max-width: theme(--breakpoint-md)) {
      padding-left: 16px;
      padding-right: 16px;

      svg {
        width: 100px;
      }
    }

    @media (max-width: 400px) {
      padding-left: 10px;
      padding-right: 10px;
    }
  }

  .BurgerMenuUser {
    display: flex;
    flex-direction: column;
    align-items: center;

    margin-top: 10vh;

    span {
      opacity: 0.6;
    }
  }

  .BurgerMenuNavigation {
    display: flex;
    flex-direction: column;
    text-align: center;
    margin-top: 5vh;

    a,
    :deep(a) {
      @apply text-white;
      font-size: 20px;
      @apply font-semibold;

      &:not(.router-link-active) {
        text-decoration: none;
      }

      margin-top: 2vh;
      margin-bottom: 2vh;
    }
  }
}
</style>
